export const DRAWER_WIDTH = 640;

export const MAX_RESIZE_WIDTH_PERCENTAGE = 80;
